<template>
  <div>
    <div class="fotterdiv">
      <div class="fotterimage"><img class="fotterimages" :src="require(`@/image/图层.png`)"></div>
      <!-- 底部 -->
      <div class="fottercontent">
        <el-row :gutter="20" style="padding-top: 60px;">
          <el-col :span="6" :offset="4">
            <div>
              <img style="object-fit: cover;;height:40px"  :src="require(`@/image/导航透明.png`)"></div><br>
              <div style="display:flex;align-items:center;width:300px ;">
                <div style="height: 35px;line-height:22px;padding-right: 10px"><img style="width:19px;height:19px" :src="require(`@/image/底部电话.png`)"></div>
                <div style="width: 256px;height: 50px;font-size: 30px;font-weight: bold;color: #FFFFFF;line-height: 30px;">0571-88028115 </div><br><br><br>
              </div>
              <div style="width: 317px;height: 35px;font-size: 12px;font-weight: 500;color: #FFFFFF;line-height: 30px;opacity: 0.5;">邮箱：wohuilian@duncredit.com</div>
              <div style="width: 317px;height: 35px;font-size: 12px;font-weight: 500;color: #FFFFFF;line-height: 30px;opacity: 0.5;">地址：浙江省杭州市西湖区西溪路698号华泰创业园14#</div>
              <div style="width: 317px;height: 35px;font-size: 12px;font-weight: 500;color: #FFFFFF;line-height: 30px;opacity: 0.5;cursor: pointer;" @click="open()">浙ICP备2022023850号-1</div >
          </el-col>
          <el-col :span="2" :offset="2">
            <div class="foottitle">解决方案</div>
            <div class="footcontent">法律科技</div>
            <div class="footcontent">资产管理处置</div>
            <div class="footcontent">资产投资</div>
          </el-col>
          <el-col :span="2">
            <div class="foottitle">新闻资讯</div>
            <div class="footcontent">最新动态</div>
            <div class="footcontent">媒体关注</div>
            <div class="footcontent">行业资讯</div>
            <!-- <div class="footcontent">产品</div> -->
          </el-col>
          <el-col :span="2">
            <div class="foottitle">关于我们</div>
            <div class="footcontent">企业介绍</div>
            <div class="footcontent">企业文化</div>
            <div class="footcontent">加入我们</div>
            <div class="footcontent">联系我们</div>
          </el-col>
          <el-col :span="2">
            <div class="foottitle">企业微信</div>
            <div><img style="width:90%;" :src="require(`@/image/二维码1.png`)"></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="phonefotter">
      <div class="fotterdivs">
        <div style="width:90vw;margin: 0 auto;">
          <el-row :gutter="20" >
            <el-col :span="19" >
              <div style="width:1.33rem;height:1.33rem"><img style="object-fit: cover;width:100%;" :src="require(`@/image/导航透明.png`)"></div>
              <div style="display:flex;align-items:center;width: 5.27rem;height: 0.2rem;margin-bottom: 0.3rem;">
                <div style="height: 0.7rem;line-height:0.22rem;padding-right: 0.1rem"><img style="width:0.19rem;height:0.19rem" :src="require(`@/image/底部电话.png`)"></div>
                <div style="width: 5.23rem;height:0.26rem;font-size: 0.36rem;font-weight: bold;color: #FFFFFF;line-height: 0.36rem;">0571-88028115 </div><br><br><br>
              </div>
              <div style="width: 5.27rem;height: 0.3;font-size: 0.2rem;font-weight: 500;color: #FFFFFF;line-height: 0.3rem;opacity: 0.5;">邮箱：wohuilian@duncredit.com</div>
              <div style="width: 5.27rem;height: 0.3;font-size: 0.2rem;font-weight: 500;color: #FFFFFF;line-height: 0.3rem;opacity: 0.5;">地址：浙江省杭州市西湖区西溪路698号华泰创业园14#</div>
              <div style="width: 5.27rem;height: 0.3;font-size: 0.2rem;font-weight: 500;color: #FFFFFF;line-height: 0.3rem;opacity: 0.5;margin-bottom: 0.2rem;cursor: pointer;"  @click="open" >浙ICP备2022023850号-1</div >

            </el-col>
            <el-col :span="5">
              <div class="foottitle">企业微信</div>
              <div style="width:1.23rem"><img style="width:100%;object-fit: cover;" :src="require(`@/image/二维码1.png`)"></div>
            </el-col>
          </el-row>
        </div>
        <div style="background-color:#659BE8;height: 1.3rem;line-height:0.5rem;text-align: center;" @click="toTop">
          <div style="width:100%;text-align: center;">
            <div style="width:0.37rem;margin: auto;"><img style="width:100%;object-fit: cover;" :src="require(`@/image/返回顶部.png`)"></div></div>
            <div style="font-size:0.3rem;color: #FFFFFF;">返回顶部</div>
        </div>
      </div>  
    </div>
    
  </div>
  
</template>

<script>
export default {
methods:{
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    open(){
      window.open("https://beian.miit.gov.cn")
    },
}
}
</script>

<style>
@media screen and (min-width: 750px) {
  .fotterdiv{width:100%;z-index:100;padding-top: 5%;}
  .fotterimage{position:absolute;width:100%;margin-top:-10%;z-index: 1000;}
  .fotterimages{position: relative;width: 100%;}
  .fottercontent{width:100%;height:295px;background-color:#060B21;position: absolute;}
  .foottitle{width: 8.25rem;height: 18px;font-size: 1.3rem;font-weight: bold;color: #FFFFFF;line-height: 19px;margin-bottom: 30px;}
  .footcontent{width: 95px;height: 30px;font-size: 0.85rem;font-weight: 500;color: #FFFFFF;line-height: 30px;opacity: 0.5;}
  .phonefotter{display: none;}
}
@media screen  and (max-width: 750px){
  .fotterdiv{display: none;}
  .fotterdivs{height:3.5rem;background-color: #060B21;}
  .foottitle{width: 0.81rem;height: 0.2rem;font-size: 0.2rem;font-weight: bold;color: #FFFFFF;line-height: 0.2rem;margin-bottom: 0.3rem;margin-top: 0.5rem;}
  
}
</style>